import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { resetClinic } from "../lib/clinicState";

// MT-12B: persistent, unmissable banner while a superadmin is inside a tenant.
// Exit revokes the short-lived support session server-side, clears ALL
// tenant-specific frontend state and reloads so nothing from this clinic survives.
export async function leaveSupportMode() {
  try { await api.post("/saas/support/exit"); } catch { /* expired sessions still clear locally */ }
  resetClinic();
  try { localStorage.removeItem("rx_print_cost"); sessionStorage.clear(); } catch { /* noop */ }
  window.location.href = "/superadmin";
}

export function SupportModeBanner({ user }) {
  const sm = user?.support_mode;
  const [left, setLeft] = useState("");
  useEffect(() => {
    if (!sm?.expires_at) return undefined;
    const tick = () => {
      const ms = new Date(sm.expires_at).getTime() - Date.now();
      if (ms <= 0) { setLeft("expired"); leaveSupportMode(); return; }
      setLeft(`${Math.floor(ms / 60000)}m ${Math.floor((ms % 60000) / 1000)}s`);
    };
    tick();
    const iv = setInterval(tick, 1000);
    return () => clearInterval(iv);
  }, [sm?.expires_at]);
  if (!sm) return null;
  const exp = new Date(sm.expires_at);
  // clinic_name is derived SERVER-SIDE from the tenant's own Clinic Profile (fallback: control-plane name)
  const clinicName = sm.clinic_name || sm.tenant_name;
  return (
    <div className="sticky top-0 z-50 bg-amber-500 text-slate-950 text-sm font-semibold px-4 py-2 flex flex-wrap items-center gap-x-4 gap-y-1 border-b-2 border-amber-700" data-testid="support-mode-banner" role="alert">
      <span className="uppercase tracking-widest">SUPERADMIN SUPPORT MODE</span>
      <span className="flex items-baseline gap-2">
        <span data-testid="support-mode-tenant">Clinic: {clinicName}</span>
        {clinicName !== sm.tenant_name && <span className="font-normal text-xs opacity-80" data-testid="support-mode-tenant-platform-name">({sm.tenant_name})</span>}
        <span className="font-mono font-normal text-[10px] opacity-75" data-testid="support-mode-tenant-id" title={sm.tenant_id}>{sm.tenant_short_id || sm.tenant_id}</span>
      </span>
      <span data-testid="support-mode-expiry">Expires {exp.toLocaleTimeString()} ({left})</span>
      <span className="font-normal truncate max-w-[40ch]" title={sm.reason}>Reason: {sm.reason}</span>
      {!sm.linked_doctor_id && <span className="font-normal">· no prescribing (not a linked doctor here)</span>}
      <button onClick={leaveSupportMode} className="ml-auto px-3 py-1 rounded bg-slate-950 text-amber-300 hover:bg-slate-800" data-testid="support-mode-exit-btn">Exit support mode</button>
    </div>
  );
}
